import { Children, ReactNode } from "react";
import { proxyNumber } from "@ui";
import { Button, Chip, CopyElement, Hint } from "@ui";
import style from "./TableRow.module.scss";
import cn from "classnames";
import { Link } from "react-router-dom";
import { IUserProxy } from "@interfaces/admin/userProxy";
import { EOperator } from "@interfaces/operator.enum";
import { KyivstarSvg, LifecellSvg, VodafoneSvg } from "pages/admin/StatisticsPage/svg";

export function TableRow({
    data
}: {
    data: IUserProxy
}) {
    const expiration_date = data.end_date ? getTimeDifference(data.end_date) : "Проксі ще готується";

    return (
        <div className={style.row} data-customer-proxy={data.id}>
            <Fields>
            <div className={style.cell}>
                <CopyElement
                    element={<p className={style.userId}>№{proxyNumber(data)}</p>}
                    copyText={proxyNumber(data)}
                />
            </div>
            <div className={cn(style.cell, "flex gap-[5px] items-center")}>
                {
                    {
                        [EOperator.Kyivstar.toLocaleLowerCase()]: <KyivstarSvg />,
                        [EOperator.Vodafone.toLocaleLowerCase()]: <VodafoneSvg />,
                        [EOperator.lifecell.toLocaleLowerCase()]: <LifecellSvg />,
                    }[data.operator.toLocaleLowerCase()]
                }
                <p className={style.operatorName}>{data.operator}, Ukraine</p>
            </div>
            <div className={style.cell}>
                <div
                    className={cn(
                        "rounded-full text-white py-[8px] px-[20px] text-[13px] leading-[13px] font-semibold",
                        data.tariff_name === "Silver" && "bg-[#aab3d3]",
                        data.tariff_name === "Platinum" && "bg-[#c6b164]",
                        data.tariff_name === "Brilliant" && "bg-[#1E9EEE]"
                    )}
                >{data.tariff_name}</div>
            </div>
            <div className={style.cell}>
                {
                    typeof expiration_date === "string"
                        ? <Chip
                            color={"green"}
                            size="middle"
                            text={expiration_date}
                        />
                        : <Hint
                            targetElement={
                                <Chip
                                    color={!expiration_date || expiration_date?.days < 3 ? "red" : "green"}
                                    size="middle"
                                    text={expiration_date ? expiration_date.days + " д, " + expiration_date.hours + " год, " + expiration_date.minutes + " хв " : "Прострочено"}
                                />
                            }
                            hintText={
                                <>
                                    Після закінчення терміну дії, проксі необхідно буде <br />
                                    знову <span className="font-bold">активувати</span> його. Поповнюйте баланс для <br />
                                    автопродовження проксі.
                                </>
                            }
                        />
                }
            </div>
            </Fields>
        </div>
    )
}

function getTimeDifference(targetDateStr: string) {
    const targetDate = new Date(targetDateStr);
    const now = new Date();

    const differenceInMs = targetDate.getTime() - now.getTime();

    if (differenceInMs <= 0) {
        return null;
    }

    const days = Math.floor(differenceInMs / (1000 * 60 * 60 * 24));
    const hours = Math.floor((differenceInMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((differenceInMs % (1000 * 60 * 60)) / (1000 * 60));

    return {
        days,
        hours,
        minutes
    };
}
function Fields({ children }: { children: ReactNode }) {
    return <>{Children.toArray(children).map((child, index) => <div key={index} className={style.field}>
        <span className={style.fieldLabel}>{["Порт", "Оператор", "Тариф", "Термін дії"][index]}</span>{child}
    </div>)}</>;
}
